import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GlobalArticleCard from '~/components/molecules/Editorial/Global/GlobalArticleCard.vue';
export default {
  name: 'GlobalListArticleCard',
  components: {
    GlobalArticleCard: GlobalArticleCard
  },
  props: {
    articles: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  methods: {
    articleColor: function articleColor(arg) {
      var filter = this.filters.find(function (e) {
        return e.label === arg;
      });
      return filter ? filter.color : '#000';
    }
  }
};